import { ILocationService } from 'angular';
import { SdcActionsService } from './../../../sdc/flux/sdc-actions.service';
import { ISdcStore } from './../../../sdc/flux/sdc-store.interface';

export class SdcWizardStepperService {
  static $inject: string[] = ['$mdStepper', '$location', 'sdcActions', 'Rollbar', 'SDCStore'];

  private _sdcKey: string;

  constructor(
    private $mdStepper,
    private $location: ILocationService,
    private sdcActions: SdcActionsService,
    private Rollbar,
    private SDCStore: ISdcStore,
  ) {}

  back = (): void => {
    const moved = this._mdBack();
    if (moved) this.setStep();
  };

  next = (): void => {
    const moved = this._mdNext();
    if (moved) this.setStep();
  };

  get sdcKey() {
    return this._sdcKey;
  }

  set sdcKey(key) {
    this._sdcKey = key;
  }

  get stepperId() {
    return this.sdcKey + '-stepper';
  }

  // Initializes stepper via stepper ID.
  //   Assumes that stepper id ===  sdcKey + '-stepper'
  init(sdcKey) {
    // Don't use setter here. The SDC Store is already set with activeWizardStep. No need to set again.
    this.sdcKey = sdcKey;
    const stepper = this._mdStepper();
    if (!stepper) {
      const err = new Error(`Stepper with ID ${this.stepperId} not found`);
      this.Rollbar.error(err);
      return;
    }
    // Load active step from store. Should account for both query params and last active step
    const step = this.SDCStore.getCurrentSdcState(sdcKey).wizard.activeWizardStep;
    const moved = stepper.goto(step - 1);
    if (!moved) {
      console.warn(`Could not load step ${step} for wizard ${sdcKey}`);
    } else {
      this.$location.search('activeWizardStep', step).replace();
    }
  }

  // For easier mocking
  _mdBack() {
    return this._mdStepper().back();
  }

  _mdNext() {
    return this._mdStepper().next();
  }

  _mdCurrStep() {
    return this._mdStepper().currentStep;
  }

  _mdStepper() {
    return this.$mdStepper(this.stepperId);
  }

  public setStep() {
    // $mdStepper step is 0 indexed
    const newStep = this._mdCurrStep() + 1;
    this.sdcActions.setCurrentSdcState(this.sdcKey, 'wizard', 'activeWizardStep', newStep);
    this.$location.search('activeWizardStep', newStep).replace();
  }
}
